/**
 * Configurable undo window and shared state shape for delayed inbox sends.
 *
 * Where: `InboxPendingSendContext` runs the timer and undo bar; `ConversationView` / `MessageInput` queue sends.
 * Uses: pure constants/types only.
 * Behavior: after delay elapses the provider POSTs the message; `fromDraft` can collapse AI draft UI on commit.
 */
export const INBOX_SEND_DELAY_SECONDS = 5;

export type InboxPendingSendState = {
  message: string;
  countdown: number;
  /** Target conversation; required so a send can finish after the user switches chats. */
  chatId: string;
  /** When true, hide AI draft after this send is committed (countdown finished). */
  fromDraft?: boolean;
  /** Shown on the global undo bar (e.g. prospect name). */
  chatLabel?: string;
};
